<template>
  <b-card no-body class="mb-1" v-if="this.currentUser.info.role_id == 8">
    <b-card-header header-tag="header" class="p-3" role="tab">
      <span class="m-1">Informasi Perusahaan</span>
      <b-button v-b-toggle.accordion-4 variant="yellow" class="chevron">
        <span class="when-open">
          <b-icon icon="chevron-up" />
        </span>
        <span class="when-closed">
          <b-icon icon="chevron-down" />
        </span>
      </b-button>
    </b-card-header>

    <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <div class="container">
            <b-alert v-if="sectionRejectionMessages.length > 0" show variant="warning" class="mb-4">
              <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
              <strong>Informasi Penolakan (Informasi Perusahaan):</strong>
              <div v-for="(msg, idx) in sectionRejectionMessages" :key="idx" class="mt-2 ml-4">
                <p class="mb-1"><strong>Alasan:</strong> {{ msg.note }}</p>
                <div v-if="msg.fields && msg.fields.length > 0">
                  <p class="mb-0"><strong>Data atau informasi yang memerlukan perbaikan:</strong></p>
                  <ol class="mb-2">
                    <li v-for="f in msg.fields" :key="f.field" class="font-weight-bold">{{ f.label }}</li>
                  </ol>
                </div>
              </div>
              <hr v-if="sectionRejectionMessages.length > 0">
              <p class="mt-2 mb-0">Untuk dapat melakukan pengajuan kembali mohon dapat memperbarui informasi perusahaan anda pada kolom yang berwarna merah di bawah ini.</p>
            </b-alert>
            <b-form @submit.prevent="updateDataUsaha">
            <div class="row">
              <span style="font-size: 12px;">Note : (*) Wajib diisi</span>
            </div>
            <input type="hidden" name="id" v-model="form.id">
            <div class="row">
              <div class="col">
                <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('jabatan')}">Jabatan</label>
                    <br>
                    <b-form-select v-model="form.jabatan" :options="options.jabatan" required :class="{'is-invalid': allRejectedFields.includes('jabatan')}"></b-form-select>
              </div>
              <div class="col">
                <label for="fname">Jenis Badan Usaha</label>
                    <br>
                    <b-form-select v-model="form.jenis_badan_usaha" :options="options.jenis_badan_usaha" required></b-form-select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('nama_perusahaan')}">Nama Perusahaan</label>
                    <br>
                    <b-form-input type="text" v-model="form.nama_perusahaan" placeholder="Masukan nama perusahaan" required :class="{'is-invalid': allRejectedFields.includes('nama_perusahaan')}"></b-form-input>
              </div>
            </div>
              

              <div class="row">
                <div class="col-sm-8">
                  <div class="alamat mt-3">
                    <label for="fc_identitas_diri_pimpinan">Foto kopi Identitas Pimpinan</label>
                    <br>
                    <b-form-file class="mt-3" plain @change="imageChangePimpinan" required></b-form-file>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <br>
                    <b-img thumbnail fluid :src="thumbnail.fc_identitas_diri_pimpinan" alt="Gambar Identitas diri"></b-img>
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="npwp_perusahaan" :class="{'text-danger font-weight-bold': allRejectedFields.includes('npwp_perusahaan')}">NPWP Perusahaan</label>
                    <br>
                    <b-form-input type="text" v-model="form.npwp_perusahaan" placeholder="Masukan npwp perusahaan" required :class="{'is-invalid': allRejectedFields.includes('npwp_perusahaan')}"></b-form-input>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fc_npwp_perusahaan">Foto kopi NPWP perusahaan</label>
                    <br>
                    <b-form-file class="mt-3" plain @change="imageChangeNpwp" required></b-form-file>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <br>
                    <b-img thumbnail fluid :src="thumbnail.fc_npwp_perusahaan" alt="Gambar npwp perusahaan"></b-img>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="no_akta">No. Akta Pendirian</label>
                    <br>
                    <b-form-input type="text" v-model="form.no_akta" placeholder="Masukan nomor akta pendirian" required></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="no_akta">No. Akta Perubahan Terakhir</label>
                    <br>
                    <b-form-input type="text" v-model="form.no_akta_perubahan" placeholder="Masukan nomor akta perubahan terakhir" required></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-8">
                  <div class="alamat mt-3">
                    <label for="fc_no_akta">Foto kopi No Akta Pendirian + Perubahan Terakhir</label>
                    <br>
                    <b-form-file class="mt-3" plain @change="imageChangeNoAkta" required></b-form-file>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <br>
                    <b-img thumbnail fluid :src="thumbnail.fc_no_akta" alt="Gambar No Akta"></b-img>
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="no_surat_izin_usaha">Nomor Induk Berusaha (NIB)</label>
                    <br>
                    <b-form-input type="text" v-model="form.no_surat_izin_usaha" placeholder="Masukan nomor surat ijin usaha" required></b-form-input>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fc_surat_izin_usaha">Foto kopi Nomor Induk Berusaha</label>
                    <br>
                    <b-form-file class="mt-3" plain @change="imageChangeSuratIzinUsaha" required></b-form-file>
                  </div>
                </div>
                 <div class="col">
                  <div class="alamat mt-3">
                    <br>
                    <b-img thumbnail fluid :src="thumbnail.fc_surat_izin_usaha" alt="Gambar surat ijin usaha"></b-img>
                  </div>
                </div>
              </div>

              <div class="row ">
                  <div class="col">
                      <div class="alamat mt-3">
                          <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('alamat')}">Alamat Perusahaan</label>
                          <br>
                            <b-form-input v-model="form.alamat" placeholder="Masukan alamat perusahaan" required :class="{'is-invalid': allRejectedFields.includes('alamat')}"></b-form-input>
                      </div>
                  </div>
              </div>

              <div class="row ">
                  <div class="col">
                      <div class="alamat mt-3">
                          <label for="provinsi">Provinsi</label>
                          <br>
                          <b-form-select v-model="form.provinsi" :value.sync="form.provinsi" :options="options.provinsi" @input="provinsiformChange" required></b-form-select>
                      </div>
                  </div>
                  <div class="col">
                      <div class="alamat mt-3">
                          <label for="exampleFormControlSelect7">Kota / Kabupaten</label>
                          <br>
                          <b-form-select v-model="form.kota" :value.sync="form.kota" :options="options.kota" @input="kotaformChange" required></b-form-select>
                      </div>
                  </div>
              </div>

              <div class="row ">
                  <div class="col">
                      <div class="alamat mt-3">
                          <label for="kecamatan">Kecamatan</label>
                          <br>
                          <b-form-select v-model="form.kecamatan" :value.sync="form.kecamatan" :options="options.kecamatan" @input="kecamatanformChange" required></b-form-select>
                      </div>
                  </div>
                  <div class="col">
                      <div class="alamat mt-3">
                          <label for="desa">Desa / Kelurahan</label>
                          <br>
                          <b-form-select v-model="form.kelurahan" :value.sync="form.kelurahan" :options="options.kelurahan" required></b-form-select>
                      </div>
                  </div>
              </div>

              <div class="row ">
                  <div class="col">
                      <div class="alamat mt-3">
                          <label for="fname">Kode Pos</label>
                          <br>
                          <b-form-input v-model="form.kode_pos" placeholder="Masukan kode pos" required></b-form-input>
                      </div>
                  </div>
                  <div class="col">
                      <div class="alamat mt-3">
                          <label for="fname">Negara</label>
                          <br>
                          <b-form-input v-model="form.negara" placeholder="Masukan negara" required></b-form-input>
                        </div>
                  </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="mt-3">
                    <label for="no_telp">No.Telp Perusahaan</label>
                    <br>
                    <b-form-input v-model="form.no_telp" placeholder="Masukan no telepon perusahaan" required></b-form-input>
                  </div>
                </div>
                <div class="col">
                  <div class="mt-3">
                    <label for="no_telp">Tanggal Perusahaan Didirikan</label>
                    <br>
                    <input type="date" id="tanggal_pendirian" format="MM/DD/yyyy" v-model="form.tanggal_berdiri" class="form-control mb-2" required></input>
                  </div>
                </div>
              </div>

              <div class="alamat mt-4 mb-2">
                <button type="submit" class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0">Ubah Data Perusahaan</button>
              </div>

            </b-form>
          </div>
          <!-- Update data diri confirmation modal -->
          <b-modal size="sm" v-model="confirmDataUsahaModal" hide-footer hide-header>
            <div class="d-block text-center">
              <h3>Apa anda yakin ?</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="confirmUpdateDataUsaha">Ya</b-button>
              </div>
              <div class="col">
                <b-button class="mt-3" block @click="confirmDataUsahaModal = false">Tidak</b-button>
              </div>
            </div>
          </b-modal>

          <!-- Success modal for all confirmation  -->
          <b-modal size="sm" v-model="successModal" hide-footer hide-header>
            <div class="d-block text-center">
              <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
              <h3>Data usaha berhasil diubah</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="successModalEvent">Tutup</b-button>
              </div>
            </div>
          </b-modal>

        </b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>

import User from '../../api/user'
import FunderAttachment from '../../api/funderattachment'
import DataUsaha from '../../api/datausaha'
import Provinsi from '../../api/daerahindonesia/provinsi'
import Kecamatan from '../../api/daerahindonesia/kecamatan'
import Kelurahan from '../../api/daerahindonesia/kelurahan'
import Kota from '../../api/daerahindonesia/kota'


export default {
  'name': 'DataUsaha',
  props: {
    allRejectedFields: {
      type: Array,
      default: () => []
    },
    rejectionMessages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        user_id: null,
        nama_perusahaan: '',
        npwp_perusahaan: '',
        no_akta: '',
        no_akta_perubahan: '',
        no_surat_izin_usaha: '',
        jabatan: '',
        alamat: '',
        provinsi: null,
        kota: null,
        kecamatan: null,
        kelurahan: null,
        kode_pos: '',
        negara: '',
        no_telp: '',
        jenis_badan_usaha: '',
        tanggal_berdiri: '',
      },
      thumbnail: {
        id: '',
        user_id: null,
        fc_identitas_diri_pimpinan: require('@/assets/images/thumbnail.png'),
        fc_npwp_perusahaan: require('@/assets/images/thumbnail.png'),
        fc_surat_kuasa: require('@/assets/images/thumbnail.png'),
        fc_surat_izin_usaha: require('@/assets/images/thumbnail.png'),
        fc_no_akta: require('@/assets/images/thumbnail.png')
      },

      options: {
        jabatan: [
          { text: 'Direktur Utama', value: 'Direktur Utama'},
          { text: 'Direktur', value: 'Direktur' },
          { text: 'Manajer', value: 'Manajer'}
        ],
        jenis_badan_usaha: [
          { text: 'PT', value: 'PT'},
          { text: 'CV', value: 'CV' },
          { text: 'Firma', value: 'Firma'},
          { text: 'Koperasi', value: 'Koperasi'},
          { text: 'Yayasan', value: 'Yayasan'}
        ],
        provinsi: [],
        kota: [],
        kecamatan: [],
        kelurahan: [],
      },
      confirmDataUsahaModal: false,
      successModal: false
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    sectionRejectionMessages() {
      if (!this.rejectionMessages) return [];
      
      return this.rejectionMessages.map(msg => {
        const filteredFields = msg.fields ? msg.fields.filter(f => {
          const model = (f.model || '').trim().toLowerCase();
          return model === 'datausaha';
        }) : [];

        if (filteredFields.length > 0) {
          return {
            note: msg.note,
            fields: filteredFields
          };
        }
        return null;
      }).filter(msg => msg !== null);
    }
  },
  methods: {
    loadData() {
      User.show(this.currentUser.info.id)
      .then(res => {
        if (res.data && res.data.meta && res.data.meta.code == 200) {
          let dataUsaha = res.data.data.data_usaha
          let funderAttachment = res.data.data.funderattachment
          
          if (dataUsaha) {
            this.form = { ...this.form, ...dataUsaha }
          }
          
          if (funderAttachment) {
            this.thumbnail.id = funderAttachment.id || ''
            this.thumbnail.user_id = funderAttachment.user_id || null
            this.thumbnail.fc_identitas_diri_pimpinan = funderAttachment.fc_identitas_diri_pimpinan ? (process.env.API_URL + funderAttachment.fc_identitas_diri_pimpinan) : this.thumbnail.fc_identitas_diri_pimpinan
            this.thumbnail.fc_npwp_perusahaan = funderAttachment.fc_npwp_perusahaan ? (process.env.API_URL + funderAttachment.fc_npwp_perusahaan) : this.thumbnail.fc_npwp_perusahaan
            this.thumbnail.fc_surat_izin_usaha = funderAttachment.fc_surat_izin_usaha ? (process.env.API_URL + funderAttachment.fc_surat_izin_usaha) : this.thumbnail.fc_surat_izin_usaha
            this.thumbnail.fc_no_akta = funderAttachment.fc_no_akta ? (process.env.API_URL + funderAttachment.fc_no_akta) : this.thumbnail.fc_no_akta
          }
        }

        Provinsi.index()
        .then(res => {
          let resData = res.data && res.data.provinsi ? res.data.provinsi : [];
          const arrData = resData.map(item => ({
            value: item.id,
            text: item.nama
          }));
          this.options.provinsi = arrData;
        })
        .catch(err => console.log(err))

        if (this.form && this.form.provinsi) {
          Kota.index(this.form.provinsi)
          .then(res => {
            let resData = res.data && res.data.kota_kabupaten ? res.data.kota_kabupaten : [];
            const arrData = resData.map(item => ({
              value: item.id,
              text: item.nama
            }));
            this.options.kota = arrData;
          })
          .catch(err => console.log(err))
        }

        if (this.form && this.form.kota) {
          Kecamatan.index(this.form.kota)
          .then(res => {
            let resData = res.data && res.data.kecamatan ? res.data.kecamatan : [];
            const arrData = resData.map(item => ({
              value: item.id,
              text: item.nama
            }));
            this.options.kecamatan = arrData
          })
          .catch(err => console.log(err))
        }

        if (this.form && this.form.kecamatan) {
          Kelurahan.index(this.form.kecamatan)
          .then(res => {
            let resData = res.data && res.data.kelurahan ? res.data.kelurahan : [];
            const arrData = resData.map(item => ({
              value: item.id,
              text: item.nama
            }));
            this.options.kelurahan = arrData;
          })
          .catch(err => console.log(err))
        }
      })
      .catch(err => console.log(err))
    },

    provinsiformChange() {
      Kota.index(this.form.provinsi)
      .then(res => {
        let resData = res.data.kota_kabupaten;
        const arrData = [];
        for (let i = 0; i < resData.length; i++) {
          arrData.push({
            value: resData[i].id,
            text: resData[i].nama
          });
        }
        this.options.kota = arrData;
      })
      .catch(err => console.log(err))
    },

    kotaformChange() {
      // console.log('Kota changed');
      Kecamatan.index(this.form.kota)
      .then(res => {
        let resData = res.data.kecamatan;
        const arrData = [];
        for (let i = 0; i < resData.length; i++) {
          arrData.push({
            value: resData[i].id,
            text: resData[i].nama
          });
        }
        this.options.kecamatan = arrData;
      })
      .catch(err => console.log(err))
    },

    kecamatanformChange() {
      // console.log('Kecamatan change')
      Kelurahan.index(this.form.kecamatan)
      .then(res => {
        let resData = res.data.kelurahan;
        const arrData = [];
        for (let i = 0; i < resData.length; i++) {
          arrData.push({
            value: resData[i].id,
            text: resData[i].nama
          });
        }
        this.options.kelurahan = arrData;
      })
      .catch(err => console.log(err))
    },


    imageChangePimpinan(e) {
      let image = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = res => {
        this.thumbnail.fc_identitas_diri_pimpinan = res.target.result
      }
    },

    imageChangeNoAkta(e) {
      let image = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = res => {
        this.thumbnail.fc_no_akta = res.target.result
      }
    },
    imageChangeNpwp(e) {
      let image = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = res => {
        this.thumbnail.fc_npwp_perusahaan = res.target.result
      }
    },
    // imageChangeSuratKuasa(e) {
    //   let image = e.target.files[0];
    //   let reader = new FileReader();
    //   reader.readAsDataURL(image);
    //   reader.onload = res => {
    //     this.thumbnail.fc_surat_kuasa = res.target.result
    //   }
    // },
    imageChangeSuratIzinUsaha(e) {
      let image = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = res => {
        this.thumbnail.fc_surat_izin_usaha = res.target.result
      }
    },
    updateDataUsaha() {
      this.confirmDataUsahaModal = true
    },
    confirmUpdateDataUsaha() {
      if (this.thumbnail.fc_identitas_diri_pimpinan.length < 100) {
        this.thumbnail.fc_identitas_diri_pimpinan = null
      }

      if (this.thumbnail.fc_npwp_perusahaan.length < 100) {
        this.thumbnail.fc_npwp_perusahaan = null
      }

      if (this.thumbnail.fc_no_akta.length < 100) {
        this.thumbnail.fc_no_akta = null
      }

      // if (this.thumbnail.fc_surat_kuasa.length < 100) {
      //   this.thumbnail.fc_surat_kuasa = null
      // }

      if (this.thumbnail.fc_surat_izin_usaha.length < 100) {
        this.thumbnail.fc_surat_izin_usaha = null
      }
      DataUsaha.update(this.form)
      .then(res => {
        if (res.data.meta.code == 200) {
          // console.log ('data usaha updated')
          // console.log(this.thumbnail)
          FunderAttachment.update(this.thumbnail)
          .then(res => {
            // console.log(res.data)
            if (res.data.meta.code == 200) {
              this.successModal = true
              this.confirmDataUsahaModal = false
            } else {
              console.log(res.data)
            }
          })
          .catch(err => console.log(err))
        } else {
          console.log(res.data)
        }
      })
      .catch(err => console.log(err))
    },
    successModalEvent() {
      location.reload();
    }
  }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/DataUsaha.vue